!(function () {
  "use strict";

  const MOBILE_QUERY = "(max-width: 749px)";
  const SECTION_SELECTOR = '[data-section-type="product-list"]';
  const SLIDER_SELECTOR = ".product-list__mobile-slider";
  const SLIDE_SELECTOR = ".product-list__mobile-slide";
  const EQUAL_HEIGHT_CLASS = "product-list__mobile-slider--equal-height";

  function debounce(fn, wait) {
    let timeout;

    return function debounced(...args) {
      clearTimeout(timeout);
      timeout = setTimeout(() => fn.apply(this, args), wait);
    };
  }

  function resetEqualHeight(slider) {
    slider.classList.remove(EQUAL_HEIGHT_CLASS);
    slider.style.removeProperty("--product-list-slide-height");

    slider.querySelectorAll(SLIDE_SELECTOR).forEach((slide) => {
      slide.style.removeProperty("height");
      slide.style.removeProperty("min-height");
    });

    const viewport = slider.querySelector(".flickity-viewport");

    if (viewport) {
      viewport.style.removeProperty("height");
    }
  }

  function equalizeProductListSlider(slider) {
    if (!window.matchMedia(MOBILE_QUERY).matches) {
      resetEqualHeight(slider);
      return;
    }

    const slides = slider.querySelectorAll(SLIDE_SELECTOR);

    if (!slides.length) return;

    resetEqualHeight(slider);

    let maxHeight = 0;

    slides.forEach((slide) => {
      maxHeight = Math.max(maxHeight, Math.ceil(slide.scrollHeight));
    });

    if (maxHeight <= 0) return;

    slider.style.setProperty("--product-list-slide-height", `${maxHeight}px`);
    slider.classList.add(EQUAL_HEIGHT_CLASS);

    slides.forEach((slide) => {
      slide.style.height = `${maxHeight}px`;
      slide.style.minHeight = `${maxHeight}px`;
    });

    const viewport = slider.querySelector(".flickity-viewport");

    if (viewport) {
      viewport.style.height = `${maxHeight}px`;
    }

    if (slider.flkty && typeof slider.flkty.resize === "function") {
      slider.flkty.resize();
    }
  }

  function bindSlider(slider) {
    if (slider.dataset.equalHeightInit === "true") return;

    slider.dataset.equalHeightInit = "true";

    const section = slider.closest(SECTION_SELECTOR);
    const equalize = debounce(() => equalizeProductListSlider(slider), 100);

    if (section) {
      section.addEventListener("theme:slider:loaded", (event) => {
        if (event.detail?.slider === slider) {
          requestAnimationFrame(equalize);
        }
      });
    }

    document.addEventListener("theme:resize:width", equalize);

    slider.querySelectorAll("img").forEach((image) => {
      if (!image.complete) {
        image.addEventListener("load", equalize);
      }
    });

    if (typeof ResizeObserver !== "undefined") {
      const observer = new ResizeObserver(equalize);
      observer.observe(slider);
    }

    requestAnimationFrame(() => {
      requestAnimationFrame(equalize);
    });
  }

  function initSection(section) {
    section.querySelectorAll(SLIDER_SELECTOR).forEach(bindSlider);
  }

  function initAll() {
    document.querySelectorAll(SECTION_SELECTOR).forEach(initSection);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", (event) => {
    if (event.target?.matches?.(SECTION_SELECTOR)) {
      initSection(event.target);
    }
  });
})();
